import React from "react"
import FieldView, {FieldViewProps} from "../../../render/view";

export default function FieldFormula_InlineEdit(props: FieldViewProps) {

    const classes = Classes('p-l-10 p-r-10', props.className)

    return <FieldView field={props.field} model={props.model} className={classes} />

}